import { Component, OnInit, Input } from '@angular/core'

@Component({
  selector: 'dmmp-modal-template',
  templateUrl: './modal-template.component.html'
})
export class ModalTemplateComponent implements OnInit {

  temporalSelectedEvent
  selectedStartDate
  selectedEndDate
  @Input() itemsOrder
  isModalOpen = false

  constructor() { }

  ngOnInit(): void {
  }

}
